var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embedded-access",attrs:{"role":"status"}},[_vm._v(_vm._s(_vm.error || '正在接入平台登录信息…'))])
}
var staticRenderFns = []

export { render, staticRenderFns }